var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#ECFEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10102_14270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 12V14.6667",
    stroke: "#0092B8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 17.3335H14.667",
    stroke: "#0092B8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 20H14.667",
    stroke: "#0092B8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 13.3335H14.667",
    stroke: "#0092B8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 16H21.333C21.6866 16 22.0258 16.1405 22.2758 16.3905C22.5259 16.6406 22.6663 16.9797 22.6663 17.3333V21.3333C22.6663 21.687 22.5259 22.0261 22.2758 22.2761C22.0258 22.5262 21.6866 22.6667 21.333 22.6667H10.6663C10.3127 22.6667 9.97358 22.5262 9.72353 22.2761C9.47348 22.0261 9.33301 21.687 9.33301 21.3333V15.3333C9.33301 14.9797 9.47348 14.6406 9.72353 14.3905C9.97358 14.1405 10.3127 14 10.6663 14H11.9997",
    stroke: "#0092B8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.6668V10.6668C20 10.3132 19.8595 9.97407 19.6095 9.72402C19.3594 9.47397 19.0203 9.3335 18.6667 9.3335H13.3333C12.9797 9.3335 12.6406 9.47397 12.3905 9.72402C12.1405 9.97407 12 10.3132 12 10.6668V22.6668",
    stroke: "#0092B8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10102_14270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryHospital);
export default __webpack_public_path__ + "static/media/primaryHospital.5b4348ce02eaf6a94bac9510cb4b9fd8.svg";
export { ForwardRef as ReactComponent };